import ActionTypes from '@ziynx/action-types';
import { getActionGroup } from '@ziynx/components/utilities';

const initialState = {
  GET_USER_INIT_API: {
    fetching: false,
  },
  GET_USER_INFO_API: {
    fetching: false,
  },
  PATCH_USER_INFO_API: {
    fetching: false,
    patching: false,
    success: false,
    error: null,
  },
};

export default function reduceUser(state = initialState, action) {
  if (!action.type) {
    return state;
  }

  const actionGroup = getActionGroup(action?.type);

  switch (action.type) {
  case ActionTypes.user.getInfo.START:
  case ActionTypes.user.init.START:
    return {
      ...state,
      ...{
        [actionGroup]: {
          ...(state[actionGroup] || {}),
          fetching: true,
          error: null,
          success: false,
        },
      },
    };
  case ActionTypes.user.patch.START:
    return {
      ...state,
      ...{
        [actionGroup]: {
          ...(state[actionGroup] || {}),
          fetching: true,
          patching: true,
          success: false,
          error: null,
        },
      },
    };
  case ActionTypes.user.getInfo.SUCCESS:
  case ActionTypes.user.init.SUCCESS:
    return {
      ...state,
      ...{
        [actionGroup]: {
          ...(state[actionGroup] || {}),
          ...(action?.response ?? {}),
          fetching: false,
          error: null,
          success: true,
        },
      },
    };
  case ActionTypes.user.patch.SUCCESS:
    return {
      ...state,
      GET_USER_INIT_API: {
        ...((state.GET_USER_INIT_API || {})),
        ...action?.response,
        userInfo: {
          ...((state.GET_USER_INIT_API || {}).userInfo),
          firstName: action?.response?.firstName,
          lastName: action?.response?.lastName,
        },
      },
      ...{
        [actionGroup]: {
          ...(action?.response ?? {}),
          fetching: false,
          patching: false,
          success: true,
          error: null,
        },
      },
    };
  case ActionTypes.user.getInfo.ERROR:
  case ActionTypes.user.init.ERROR:
    return {
      ...state,
      ...{
        [actionGroup]: {
          ...(state[actionGroup] || {}),
          fetching: false,
          success: false,
          error: action?.error,
        },
      },
    };
  case ActionTypes.user.patch.ERROR:
    return {
      ...state,
      ...{
        [actionGroup]: {
          ...(state[actionGroup] || {}),
          fetching: false,
          patching: false,
          success: false,
          error: action?.error,
        },
      },
    };
  case ActionTypes.user.clearPatch:
    return {
      ...state,
      ...{
        PATCH_USER_INFO_API: {
          fetching: false,
          patching: false,
          success: false,
          error: null,
        },
      },
    };
  case ActionTypes.user.clear:
    return initialState;
  case ActionTypes.company.patch.SUCCESS: {
    return {
      ...state,
      GET_USER_INIT_API: {
        ...(state?.GET_USER_INIT_API ?? {}),
        name: action?.response?.name ?? '',
        profileImage: action?.response?.profileImage ?? {},
      },
    };
  }
  default:
    return state;
  }
}
